import { z } from 'zod'
import { parseKwacha } from '@/lib/money'

const AMOUNT_MSG = 'Enter an amount like 50 or 50.00'

/** Parse a Kwacha text box into whole ngwee (null when invalid or not above zero). */
export function amountToNgwee(text: string): number | null {
  const n = parseKwacha(text)
  return n !== null && n > 0 ? n : null
}

export const planFormSchema = z.object({
  name: z.string().trim().min(1, 'Type a name for this plan').max(80, 'Use a shorter name'),
  cadence: z.enum(['monthly', 'quarterly']),
  amount: z.string().refine((v) => amountToNgwee(v) !== null, AMOUNT_MSG),
  dueDay: z
    .string()
    .regex(/^\d{1,2}$/, 'Pick a day from 1 to 28')
    .refine((v) => Number(v) >= 1 && Number(v) <= 28, 'Pick a day from 1 to 28'),
  startsOn: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Pick a start date'),
})
export type PlanFormValues = z.infer<typeof planFormSchema>

export const enrolFormSchema = z.object({
  membershipId: z.string().min(1, 'Pick a member'),
  planId: z.string().min(1, 'Pick a plan'),
  month: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'Pick a month'),
  // Blank means "use the plan amount".
  override: z.string().refine((v) => v.trim() === '' || amountToNgwee(v) !== null, AMOUNT_MSG),
})
export type EnrolFormValues = z.infer<typeof enrolFormSchema>
